import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '../index';

import * as LocationActions from './location.actions';
import * as LocationSelectors from './location.selectors';
import { LocationModel } from '@cpd-app/core-module/models';

@Injectable({
  providedIn: 'root'
})
export class LocationFacade {
  public searchResultModel$ = this.store.pipe(
    select(LocationSelectors.getSearchResultModel)
  );
  public occupationListByLocation$ = this.store.pipe(
    select(LocationSelectors.getOccupationList)
  );

  constructor(private store: Store<AppState>) {}

  public setLocation(locationModel: LocationModel): void {
    this.store.dispatch(LocationActions.removeLocation());
    this.store.dispatch(LocationActions.setLocation({ locationModel }));
  }

  public removeLocation(): void {
    this.store.dispatch(LocationActions.removeLocation());
  }
}
